export const appConfig = {
    tenant: 'ugl-estv',
    eventId: 'd11ede35-e6bd-4936-88d7-b485f0412171',
    contestId: '876148c7-12e1-41a2-be67-6a5cc67ba7ad',
    overlayId: '758c70fc-722e-4f8c-bbbe-3a7ed601822c',
};